// src/pages/bookingModel/services/OTPservice.js (Modified getEndpointAndData)

import axios from "axios";
// NOTE: ValidatePhone is only needed if you want a safety check at the end. 
// We rely on isSLMobile/isInternational now.
import { isInternational, isSLLandline, isSLMobile, ValidatePhone } from './validationService'; 


const getEndpointAndData = (normalizedPhone, normalizedEmail, isSLMobile, isSLLandline, isInternational) => {
    let endpoint, data;

    // RULE 1 (MOST ROBUST): SL Mobile (or unclassified, valid LK number). 
    // This is the ONLY path that sends SMS + Email.
    if (isSLMobile) {
        endpoint = `${process.env.REACT_APP_BACKEND_URL}user/send-otp/srilanka`;
        data = { phoneNumber: normalizedPhone, email: normalizedEmail };
    } 
    
    // RULE 2: Anything Else (SL Landline, International, or any other type).
    // All other valid cases fall here and ONLY send to email.
    else if (isSLLandline || isInternational) {
        endpoint = `${process.env.REACT_APP_BACKEND_URL}user/send-otp/international`;
        data = { email: normalizedEmail };
    }
    
    // RULE 3: Final Catch-All (Covers valid but unclassified international numbers).
    // If it's a valid number but failed rules 1 and 2, it's not a known SL type, 
    // so it must be treated as international/email-only.
    else if (ValidatePhone(normalizedPhone)) {
         endpoint = `${process.env.REACT_APP_BACKEND_URL}user/send-otp/international`;
         data = { email: normalizedEmail };
    }
    
    // FINAL FALLBACK: Invalid or unparsable number.
    else {
        throw new Error("Phone number is invalid or its type could not be categorized for OTP sending.");
    }
    
    return { endpoint, data };
};

// ... (rest of sendOTP and verifyOTP remains the same)

/**
 * Sends the OTP using the correct regional backend service.
 * @param {string} normalizedPhone - E.164 phone number.
 * @param {string} normalizedEmail - Valid email address.
 */
export const sendOTP = async (normalizedPhone, normalizedEmail) => {
    try {
        // Call the passed functions to get boolean results
        const isMobile = isSLMobile(normalizedPhone);
        const isLandline = isSLLandline(normalizedPhone);
        const isInt = isInternational(normalizedPhone);

        const { endpoint, data } = getEndpointAndData(
            normalizedPhone,
            normalizedEmail,
            isMobile,
            isLandline,
            isInt
        );

        // console.log(`Sending OTP to endpoint: ${endpoint}`);

        const response = await axios.post(endpoint, data);
        return response?.data?.data;

    } catch (error) {
        console.error("Error sending OTP:", error);
        const userMessage = error.response?.data?.message || "Failed to send verification code. Please try again.";
        throw new Error(userMessage);
    }
};


/**
 * Verifies the OTP using the correct regional backend service.
 */
export const verifyOTP = async (normalizedPhone, normalizedEmail, otp) => {
    try {
        // Determine endpoint based on phone type for verification
        const isSLPhone = isSLMobile(normalizedPhone); 
        
        const endpoint = isSLPhone
            ? `${process.env.REACT_APP_BACKEND_URL}user/verify-otp/srilanka`
            : `${process.env.REACT_APP_BACKEND_URL}user/verify-otp/international`;

        // Payload adjusts based on endpoint
        const data = isSLPhone 
            ? { phoneNumber: normalizedPhone, email: normalizedEmail, otp } 
            : { email : normalizedEmail, otp };

        const response = await axios.post(endpoint, data);
        
        return response.data.success || response?.data?.data;

    } catch (error) {
        console.error("Error verifying OTP:", error);
        const userMessage = error.response?.data?.message || "OTP Verification failed. Please check your code and try again.";
        throw new Error(userMessage);
    }
};